import React, { useEffect, useState } from 'react';
import IonIcon from '@reacticons/ionicons';
import { selectProfile } from "../store/profile";
import { useSelector } from "react-redux";
import { googleLogout } from '@react-oauth/google';
import { apiRequest, API_CONSTANTS } from '../libs/apiRequest';
import { useNavigate } from "react-router-dom";
import defaultProfile from "../assets/images/default_profile.png";
import '../css/gtc-navbar.css';

function NavBar() {
    const profile = useSelector(selectProfile);
    const [navProfile, setNavProfile] = useState({ email: null, pic: null });
    const navigate = useNavigate();
    const logOut = async () => {
        const data = await apiRequest({
            method: "GET",
            api: API_CONSTANTS.PUBLIC_API,
            fn: "logout"
        });

        if (data.status === 200) {
            googleLogout();
            navigate("/login");
            window.location.reload();
        }
    };

    const login = async () => {
        navigate("/login");
    }

    useEffect(() => {
        setNavProfile(profile);
    }, [profile])

    // console.log("Profile", profile)

    return (
        <nav className="navbar">
            <div className="navbar-container">
                <h1 className="brand-logo">
                    <a href='/'>
                        <span style={{color: "var(--secondary-color)"}}>Go</span>
                        Trycatch
                    </a>
                </h1>
                
                <div className="nav-login">
                    <div className="dropdown-wrapper">
                        <input type="checkbox" id="dropdown-toggle" className="dropdown-toggle" />
                        {navProfile?.email ? (
                            <label 
                                htmlFor="dropdown-toggle" 
                                className="dropdown-label" 
                                style={{ 
                                    backgroundImage: `url("${!navProfile?.pic || navProfile?.pic == "null" ? defaultProfile : navProfile.pic}")` 
                                }}
                            ></label>
                        ) : (
                            <a onClick={login} className="button-login">Login</a>
                        )}

                        <div className="dropdown-menu">
                            <div className="upper-triangle"></div>
                            <div style={{padding: '1rem'}}>
                                {profile.name && <p className="dropdown-profile-name">{profile.name}</p>}
                                {profile.email && <p className="dropdown-profile-name">{profile.email}</p>}
                            </div>
                            <hr style={{ border: '1px solid rgba(255,255,255,0.1)', margin: 0 }} />
                            <ul className="dropdown-list">
                                <li onClick={() => navigate("/subscriptions")}>
                                    <IonIcon name="analytics-outline" className="dropdown-list-icon"/>
                                    <span>Subscription</span>
                                </li>
                                <li onClick={logOut}>
                                    <IonIcon name="log-out-outline" className="dropdown-list-icon"/>
                                    <span>Logout</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default NavBar;



                